import invariant from "invariant";
import { createContext, useContext } from "react";

export const ServiceModalsContext = createContext();

export const useServiceModalsContext = () => {
  const context = useContext(ServiceModalsContext);

  invariant(context, "Unreachable ServiceModalsProvider context");

  return {
    visible: context.visible,
    modalKey: context.modalKey,
    props: context.props,
    openModal: context.openModal,
    closeModal: context.closeModal,
  };
};
